import React, { useEffect, useEffectEvent } from "react";
import { useLocation, Outlet, useNavigate } from "react-router";
import { signInAnonymously } from "firebase/auth";
import { useFirebaseAuth } from "@/contexts/UserProfileContext/UserProfileContext";

export default function AuthenticatedRoute(props: { allowAnonymous?: boolean }) {
    const { allowAnonymous } = props;

    const { auth, user, isAuthLoading, isAnonymous } = useFirebaseAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const determineSignin = useEffectEvent(() => {
        if (user) {
            if (isAnonymous && !allowAnonymous) {
                navigate("/", { replace: true });
            }
        } else if (allowAnonymous) {
            auth.beforeAuthStateChanged((newUser) => {
                if (auth.currentUser && newUser && !newUser.isAnonymous) {
                    // Abort anonymous sign-in
                    throw new Error("User is already signed in with a non-anonymous account");
                }
            });
            signInAnonymously(auth);
        } else {
            navigate(
                {
                    pathname: "/sign_in",
                    search: `redirectTo=${location.pathname}`,
                },
                { replace: true }
            );
        }
    });

    useEffect(() => {
        if (!isAuthLoading) {
            if (!user && allowAnonymous) {
                console.log("No user signed in. Signing in anonymously");
            }
            determineSignin();
        }
    }, [allowAnonymous, isAuthLoading, user]);

    if (isAuthLoading || !user) {
        return null;
    }

    return <Outlet />;
}
AuthenticatedRoute.defaultProps = {
    allowAnonymous: false,
};
